import { BaseQueryFn } from '@reduxjs/toolkit/dist/query';
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import { TAG_WEB_APPLICATION_SETTINGS } from 'services/TagsConstants';

import { FormDataType } from '../constants/WebAppSettingsFormConstants';

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
  build.mutation<void, FormDataType>({
    query: (patch) => {
      return {
        url: 'system/web-application-setting',
        method: 'PATCH',
        body: patch,
      };
    },
    invalidatesTags: [TAG_WEB_APPLICATION_SETTINGS],
  });
